// Profile access options
export const PROFILE_ACCESS_OPTIONS = [
  { label: 'A Long Profile', value: 'A Long Profile' },
  { label: 'Another Profile', value: 'Another Profile' },
  { label: 'Another long Profile', value: 'Another long Profile' },
  { label: 'Another short Profile', value: 'Another short Profile' },
] as const;

// Role descriptions
export enum UserRole {
  OWNER = 'OWNER',
  MANAGER = 'MANAGER',
  EMPLOYEE = 'EMPLOYEE',
  EMPLOYEE_EXPORT_LOCKED = 'EMPLOYEE_EXPORT_LOCKED',
}
export const ROLES = [
  {
    label: 'Organization Owner',
    value: UserRole.OWNER,
    description:
      'Access all functions and data, modify other organization owners, request records, access patient data, manager users',
  },
  {
    label: 'Manager',
    value: UserRole.MANAGER,
    description: 'Request records, access patient data, and manage users',
  },
  {
    label: 'Employee',
    value: UserRole.EMPLOYEE,
    description: 'Request records and access patient data',
  },
  {
    label: 'Employee (No Export)',
    value: UserRole.EMPLOYEE_EXPORT_LOCKED,
    description:
      'Request records and access patient data, without export capabilities',
  },
] as const;

export enum UserStatus {
  ACTIVE = 'ACTIVE', //'Accepted'
  UNRESPONSIVE = 'UNRESPONSIVE', // matches BE; user invited >7 days ago, not yet accepted
  INACTIVE = 'INACTIVE', //'Deactivated'
}

export enum UserInviteStatus {
  ACCEPTED = 'ACCEPTED',
  PENDING = 'PENDING', //'Invite Sent'
  EXPIRED = 'EXPIRED', //'Unresponsive'
}

export const INVITE_STATUS_LABELS = {
  [UserInviteStatus.PENDING]: 'Invite Sent',
  [UserInviteStatus.EXPIRED]: 'Unresponsive',
  [UserInviteStatus.ACCEPTED]: 'Accepted',
} as const;

export const USER_STATUS_LABELS = {
  [UserStatus.ACTIVE]: 'Active',
  [UserStatus.UNRESPONSIVE]: 'Unresponsive',
  [UserStatus.INACTIVE]: 'Deactivated',
} as const;

export enum CreateUserAction {
  CREATE_AND_ADD = 'createAndAdd',
  CREATE_AND_CLOSE = 'createAndClose',
}
